export interface Result<T> {
  isError: boolean;
  data: T;
  errorCode?: string;
  errorMessage?: string;
  errors?: {
    error_code: number,
    error_details: {
      _exception_type: string,
      _exception_message: string
    }
}[]
}

export interface ErrorHandler {
  handleError(error: any): Result<any>;
}

export interface ErrorResult {
  succeeded: boolean;
  errors: ApplicationError[];
}

export interface ApplicationError {
  code: string;
  description?: string;
}

export enum ExceptionType {
  MissingOrganizationException = 'LiveDashboard.Exceptions.MissingOrganizationException'
}